import * as angular from "angular";
import { TalkingPoint } from "../models/talking-point.model";
import { TalkingPointCategory } from "../models/talking-point-category.model";
import { TalkingPointService } from "../services/talking-point.service";
import { TalkingPointCategoryService } from "../services/talking-point-category.service";

export class TalkingPointDataProvider {
    public categories;
    private talkingpoints;
    private $q: any;
    private $timeout: any;
    private __app_type: string;
    private resource: TalkingPointService;
    private categoryService: TalkingPointCategoryService;

    constructor(
        $q: any,
        $timeout: any,
        __app_type: string,
        TalkingPointService: TalkingPointService,
        TalkingPointCategoryService: TalkingPointCategoryService
    ) {
        this.$q = $q;
        this.$timeout = $timeout;
        this.__app_type = __app_type;
        this.resource = TalkingPointService;
        this.categoryService = TalkingPointCategoryService;
    }

    createPoint(talkingPoint: TalkingPoint) {
        const deferred = this.$q.defer();
        this.resource.create(talkingPoint).then(
            (response) => {
                const json = response["data"];
                if (json.success) {
                    let talkingPoint = new TalkingPoint(json.data);
                    this.addToCategories(talkingPoint);
                    deferred.resolve(talkingPoint);
                } else {
                    deferred.reject(json);
                }
            },
            (error) => deferred.reject(error)
        );
        return deferred.promise;
    }

    clearAll() {
        this.categories = null;
        this.talkingpoints = null;
    }

    addToCategories(talkingPoint) {
        this.$timeout(() => {
            let existingCategory = this.getCategory(talkingPoint.tpcname);
            if (!existingCategory) {
                this.categories.push(
                    new TalkingPointCategory({
                        otpcid: talkingPoint.otpcid,
                        tpcid: talkingPoint.tpcid,
                        tpcname: talkingPoint.tpcname,
                        points: [talkingPoint],
                    })
                );
            } else {
                let existingTalkingPoint = this.talkingPointWithID(
                    talkingPoint.tpid,
                    existingCategory.points
                );
                if (existingTalkingPoint) {
                    angular.extend(existingTalkingPoint, talkingPoint);
                } else {
                    existingCategory.points.push(talkingPoint);
                }
            }
        });
    }

    updateCategory(talkingPoint) {
        this.$timeout(() => {
            //Find point and remove it from previous category
            angular.forEach(this.categories, (category) => {
                angular.forEach(category.points, (point) => {
                    if (talkingPoint.tpid == point.tpid) {
                        let pointsIndex = category.points.indexOf(point);
                        category.points.splice(pointsIndex, 1);
                    }
                });
            });
            let newCategory = this.getCategory(talkingPoint.tpcname);

            if (newCategory) {
                //add point to new category
                newCategory.points.push(talkingPoint);
            } else {
                //create new category and add point to it
                newCategory = new TalkingPointCategory({
                    tpcid: talkingPoint.tpcid,
                    tpcname: talkingPoint.tpcname,
                    points: [talkingPoint],
                });
                this.categories.push(newCategory);
            }
        });
    }

    getCategory(name) {
        let existingCategory = null;
        angular.forEach(this.categories, (category) => {
            if (category.tpcname == name) {
                existingCategory = category;
            }
        });
        if (existingCategory) {
            return existingCategory;
        } else {
            return false;
        }
    }

    talkingPointWithID(id, points) {
        let existingPoint = null;
        angular.forEach(points, (point) => {
            if (point.tpid == id) {
                existingPoint = point;
            }
        });
        if (existingPoint) {
            return existingPoint;
        } else {
            return false;
        }
    }

    splicePoint(point, category) {
        let pointsIndex = category.points.indexOf(point);
        if (pointsIndex > -1) {
            category.points.splice(pointsIndex, 1);
        }
    }

    deletePoint(point, category) {
        const deferred = this.$q.defer();
        this.resource.delete(point).then((response) => {
            let json = response["data"];
            if (json.success) {
                this.splicePoint(point, category);
                if (category.points.length == 0) {
                    //delete category if it's the last point in the category
                    this.categoryService
                        .delete({ id: point.tpcid })
                        .then(() => {
                            let index = this.categories.indexOf(category);
                            if (index > -1) {
                                this.categories.splice(index, 1);
                            }
                            deferred.resolve(json.data);
                        });
                } else {
                    deferred.resolve(json.data);
                }
            } else {
                deferred.reject(json);
            }
        });
        return deferred.promise;
    }

    updatePoint(talkingPoint, oldPoint) {
        const deferred = this.$q.defer();
        this.resource.update(talkingPoint).then((response) => {
            let json = response["data"];
            if (json.success) {
                talkingPoint.setData(json.data);
                if (oldPoint.tpcid != talkingPoint.tpcid) {
                    this.updateCategory(talkingPoint);
                }
                deferred.resolve(talkingPoint);
            } else {
                deferred.reject(json);
            }
        });
        return deferred.promise;
    }

    getCategories() {
        const deferred = this.$q.defer();
        if (!this.categories) {
            this.categoryService.all().then(
                (response) => {
                    let json = response["data"];
                    this.categories = [];
                    for (let i = 0; i < json.data.length; i++) {
                        this.categories.push(
                            new TalkingPointCategory(json.data[i])
                        );
                    }
                    deferred.resolve(this.categories);
                },
                (error) => {
                    this.categories = [];
                    deferred.reject(error);
                }
            );
        } else {
            deferred.resolve(this.categories);
        }
        return deferred.promise;
    }

    replaceTalkingPoint(talkingpoint) {
        this.addToCategories(talkingpoint);
    }

    processSocketUpdate(socketData) {
        if (this.categories) {
            this.replaceTalkingPoint(new TalkingPoint(socketData));
        }
    }

    processSocketCreate(socketData) {
        if (this.categories) {
            this.replaceTalkingPoint(new TalkingPoint(socketData));
        }
    }

    processSocketDelete(socketData) {
        if (this.categories) {
            let category = this.getCategory(socketData.tpcname);
            angular.forEach(category.points, (point) => {
                if (point.tpid == socketData.tpid) {
                    let pointsIndex = category.points.indexOf(point);
                    category.points.splice(pointsIndex, 1);
                }
            });
        }
    }
}

angular
    .module("vcDataProvider")
    .service("TalkingPointDataProvider", TalkingPointDataProvider);
